<template>
  <div class="signup">
    <adx-modal @modal-close="toggleModal" :type="`account`" :title="`Sign up`">
      <div slot="content" class="content">
        <template v-if="!isRegister">
          <div class="content__header">
          </div>
          <div class="content__mediasocial">
            <button class="btn-block not-rounded facebook" @click="socialLogin(`facebook`, currentRoute)">
              <i class="adx-ic_facebook"></i>
              Continue with Faceboook
            </button>
            <button class="btn-block not-rounded secondary google" @click="socialLogin(`google`, currentRoute)">
              <i class="adx-ic_google"></i>
              Continue with Google
            </button>
          </div>
          <div class="content__divider">
            <span></span>
            <div class="or">OR</div>
            <span></span>
          </div>
          <div class="content__input">
            <button @click="toggleSignup" class="btn-block not-rounded primary signin">Sign up with Email</button>
          </div>
          <div class="content__fulldivider">

          </div>
          <div class="content__footer">
            <div class="signup">
              Already have an account ? <span @click="goToSignin">Sign in</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="content__header">
            <div class="content__header--title">
              Continue with <span class="color-pink" @click="socialLogin(`facebook`, currentRoute)">Facebook</span> or <span class="color-pink" @click="socialLogin(`google`, currentRoute)">Google</span>
            </div>
          </div>
          <div class="content__input">
            <adx-form
            @complete="complete"
            @goto="goto"
            :schema="schema"
            :model.sync="model"
            :error.sync="error"
            :onSubmit="onSubmit"
            :wrapper="wrapper" />
          </div>
          <div class="content__fulldivider">

          </div>
          <div class="content__footer">
            <div class="signup">
              Already have an account ? <span @click="goToSignin">Sign in</span>
            </div>
          </div>
        </template>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import Input from '@/components/Form/Input'
import Checkbox from '@/components/Form/Checkbox'
import FormAbstraction from '@/components/Form'

import api from '@/api'
import types from '@/lib/types'
import { apiV2 } from '@/api/urls'
import { authMixin } from '@/lib/mixins/authMixin'

const {
  ButtonType: { BUTTON, RESET },
  ButtonAction: { SUBMIT, APICALL, GOTO }
} = types

export default {
  name: 'adx-signin-modal',
  components: {
    'adx-modal': Modal,
    'adx-input': Input,
    'adx-checkbox': Checkbox,
    'adx-form': FormAbstraction
  },
  mixins: [ authMixin ],
  props: {

  },
  data() {
    return {
      isRegister: false,
      wrapper: {
        alertWrapper: `content`
      },
      model: {
        email: ``,
        fullname: ``,
        mobile: ``,
        company: ``,
        password: ``,
        agree: ``
      },
      error: {

      },
      onSubmit: {
        wrapper: {
          class: ``
        },
        buttons: [
          {
            type: BUTTON,
            action: SUBMIT,
            label: `Register`,
            uri: apiV2.signup,
            params: this.model,
            method: `post`, // HTTP Method
            class: `btn-block not-rounded primary signin`,
            isLoading: false
          },
        ]
      },
      schema: [
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Email Address *',
              model: 'email',
              method: 'onChange',
              validation: ['NotEmpty', 'Email']
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Full Name *',
              model: 'fullname',
              method: 'onChange',
              validation: ['NotEmpty', 'MaxLength:100']
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Phone Number *',
              model: 'mobile',
              method: 'onChange',
              validation: ['NotEmpty', 'Phone', 'MaxLength:16']
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Company Name',
              model: 'company'
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'password',
              label: 'Create Password *',
              model: 'password',
              method: 'onChange',
              validation: ['NotEmpty']
            }
          ]
        },
        {
          type: 'flex',
          fields: [
            {
              type: 'checkbox',
              label: 'I Agree',
              model: 'tnc',
              validation: ['Checked']
            },
            {
              type: 'link',
              label: 'Terms of service',
              to: 'terms-of-service',
              event: 'gototnc'
            }
          ]
        },
      ]
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    goto(name) {
      if (name === 'gototnc') {
        const route = this.$router.resolve({name: 'tos'})
        window.open(route.href, '_blank')
      }
    },
    toggleModal() {
      this.isRegister = false
      this.$emit('toggle', 'toggleSignup')
    },
    toggleSignup() {
      this.isRegister = true
    },
    goToSignin() {
      this.$emit('toggle', 'gotoSignup')
    },
    complete($event) {
      (async () => {

        const { redirect_to } = $event.args.data

        this.$router.push(redirect_to)

        this.toggleModal()
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>